import type { RootState } from '@src/core/store';
import { ProductBookingSlot } from '../types/productBookingSlot';
import { makeSteps } from '@src/stores/product';
import { getOrderedEmbedSlots } from './getOrderedEmbedSlots';
import { isSlotComplete, type IsSlotCompleteOptions } from './isSlotComplete';

type SequentialEmbedBlock = {
  blockingSlot: ProductBookingSlot;
  highlightSlot: ProductBookingSlot;
};

export const getFirstIncompleteEmbedSlot = (
  widgetId: string,
  state: RootState,
  options?: IsSlotCompleteOptions,
): SequentialEmbedBlock | null => {
  const adder = state.product.adderState[widgetId];
  const productId = adder?.productId;

  if (!adder || !productId) {
    return null;
  }

  const steps = makeSteps(widgetId, state);

  if (!steps.length) {
    return null;
  }

  const slots = getOrderedEmbedSlots(widgetId, state);

  for (const slot of slots) {
    if (!isSlotComplete(slot, widgetId, steps, state, slots, options)) {
      return { blockingSlot: slot, highlightSlot: slot };
    }
  }

  return null;
};
